import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Dimmer,
  Dropdown,
  Grid,
  Loader,
  Segment,
  Menu,
} from 'semantic-ui-react';
import { Link } from 'react-router';
import { replace, push } from 'react-router-redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { decodeSearch, encodeSearch } from '../../../utils/url';
import isNumber from '../../../utils/numbers/isNumber';
import PageNav from '../../../components/PageNav';
import UnitLayoutItem from '../../../components/UnitLayoutItem';
import NavBar from '../../../components/NavBar';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';
import { editRoutes } from '../navigations';
import config from '../../../../config';

class List extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    id: PropTypes.string,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isBranchLeaderSupervisorII: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      company: PropTypes.object,
    }),
    data: PropTypes.shape({
      maOwnerCompanyBranchID: PropTypes.number,
    }),
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        lawyerIsEnabled: PropTypes.bool,
      }),
    }),
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static getPropsToState = (props) => {
    const loading = props.loading;
    const count = props.count;
    const limit = props.limit;
    const offset = props.offset;
    const datas = props.datas || [];
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const menuIsTab = window.innerWidth <= 590;
    const unitLayoutResize = window.innerWidth < 768;
    return {
      datas,
      loading,
      count,
      limit,
      offset,
      currentPage,
      menuIsTab,
      unitLayoutResize,
    };
  }
  constructor(props) {
    super(props);
    const state = List.getPropsToState(props);
    this.state = {
      ...state,
    };
  }
  componentDidMount() {
    const query = decodeSearch(this.props.location.search);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    if (query.tab) {
      delete query.tab;
    }
    this.replaceQuery(query);
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = List.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  handleResize = () => {
    const state = {};
    const menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== this.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    const unitLayoutResize = window.innerWidth < 768;
    if (unitLayoutResize !== this.state.unitLayoutResize) {
      state.unitLayoutResize = unitLayoutResize;
    }
    this.setState({ ...state });
  }
  handleChangePage = (page) => {
    const query = decodeSearch(this.props.location.search);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    const currentPage = parseInt(page || query.page, 10);
    query.page = currentPage;
    this.setState({ currentPage });
    this.replaceQuery(query);
  }
  hasAccess(check = false) {
    const { auth, data } = this.props;
    if (auth.isHeadquarters || auth.isSuperAdmin) {
      return true;
    }
    if (auth.isBranchLeaderSupervisorII && data &&
    (data.maOwnerCompanyBranchID === auth.companyBranch.id)) {
      return true;
    }
    return check;
  }
  replaceQuery(query) {
    const { store } = this.context;
    store.dispatch(replace(`/projects/${this.props.id}/layouts/?${encodeSearch(query)}`));
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    if (value.includes(config.get('developerURL'))) {
      e.preventDefault();
      window.location.href = value;
    } else {
      store.dispatch(replace(value));
    }
  }
  render() {
    const { auth, id, location, t } = this.props;
    const { pathname } = location;
    const { store } = this.context;
    const companyServiceID = auth && auth.company && auth.company.service_company_id ? auth.company.service_company_id : '';
    const isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    const links = editRoutes(id, this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled, isMalaysia, companyServiceID).map(l => ({
      ...l,
      text: t(l.text, { ns: l.text === 'Edit' ? TRANSLATION_FILES.translation : TRANSLATION_FILES.screens }),
    }));
    return (
      <Container>
        <NavBar
          links={
            this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
            : links.map((link, key) => (
              <Menu.Item
                key={key}
                name={link.text}
                active={pathname === link.value}
                onClick={e => this.handleMenu(e, link)}
              />
            ))
          }
          rightNav={this.hasAccess() &&
            <Menu.Item fitted>
              <Button
                as={Link}
                primary
                content={t('New', { ns: TRANSLATION_FILES.constants })}
                disabled={this.state.loading}
                to={`/projects/${id}/layouts/new/`}
              />
            </Menu.Item>
          }
        />
        <Grid verticalAlign="middle" columns="equal" stackable>
          <Grid.Row>
            <Grid.Column>
              <PageNav
                floated="right"
                currentPage={this.state.currentPage}
                count={this.state.count}
                limit={this.state.limit}
                offset={this.state.offset}
                dataSize={this.state.datas.length}
                loading={this.state.loading}
                onChange={this.handleChangePage}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Dimmer
                inverted style={{ zIndex: 20 }}
                active={this.state.loading && this.state.datas.length > 0}
              >
                <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
              </Dimmer>
              <Segment.Group>
                {
                  this.state.datas.length > 0 ?
                  this.state.datas.map((unitLayout, key) => (
                    <UnitLayoutItem
                      key={key}
                      isMobile={this.state.unitLayoutResize}
                      loading={this.state.loading}
                      buttonNode={({ loading }) => (
                        <Button.Group fluid floated="right" widths={2} basic primary>
                          <Button
                            as={Link}
                            content={t('View', { ns: TRANSLATION_FILES.translation })}
                            disabled={loading}
                            to={`/projects/${id}/layouts/${unitLayout.id}/`}
                          />
                          <Button
                            content={t('Edit', { ns: TRANSLATION_FILES.translation })}
                            disabled={loading}
                            onClick={() => store.dispatch(push(`/projects/${id}/layouts/${unitLayout.id}/edit/`))}
                          />
                        </Button.Group>
                      )}
                      {...unitLayout}
                    />
                  )) : (
                    <Segment textAlign="center">
                      {
                        this.state.loading ?
                        <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                        : <p>{t('No unit layouts found')}.</p>
                      }
                    </Segment>
                  )
                }
              </Segment.Group>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row only="tablet mobile">
            <Grid.Column textAlign="center">
              <PageNav
                currentPage={this.state.currentPage}
                count={this.state.count}
                limit={this.state.limit}
                offset={this.state.offset}
                dataSize={this.state.datas.length}
                loading={this.state.loading}
                onChange={this.handleChangePage}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(List.mapStateToProps)(List));



// WEBPACK FOOTER //
// ./src/containers/Project/UnitLayouts/List.jsx